// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type FeatureListsQueryVariables = Types.Exact<{
  platform: Types.ClientPlatform;
  premiumProduct: Types.FeatureListProduct;
  projobsProduct: Types.FeatureListProduct;
}>;

export type FeatureListsQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    premium?: {
      __typename?: 'FeatureList';
      sections: Array<{
        __typename?: 'FeatureListSection';
        title: string;
        items: Array<{
          __typename?: 'FeatureListItem';
          text: string;
          isNew: boolean;
        }>;
      }>;
    } | null;
    projobs?: {
      __typename?: 'FeatureList';
      sections: Array<{
        __typename?: 'FeatureListSection';
        title: string;
        items: Array<{
          __typename?: 'FeatureListItem';
          text: string;
          isNew: boolean;
        }>;
      }>;
    } | null;
  } | null;
};

export type CampaignPageFeatureListFragment = {
  __typename?: 'FeatureList';
  sections: Array<{
    __typename?: 'FeatureListSection';
    title: string;
    items: Array<{
      __typename?: 'FeatureListItem';
      text: string;
      isNew: boolean;
    }>;
  }>;
};

export const CampaignPageFeatureListFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CampaignPageFeatureList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageFeatureListFragment, unknown>;
export const FeatureListsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureLists' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'platform' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ClientPlatform' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'premiumProduct' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FeatureListProduct' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'projobsProduct' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FeatureListProduct' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'premium' },
                  name: { kind: 'Name', value: 'featureList' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'product' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'premiumProduct' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'platform' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'platform' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CampaignPageFeatureList',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'projobs' },
                  name: { kind: 'Name', value: 'featureList' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'product' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'projobsProduct' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'platform' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'platform' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CampaignPageFeatureList',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CampaignPageFeatureList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureListsQuery, FeatureListsQueryVariables>;
